module.exports = ".content {\n  text-align: center;\n}\n.dialogContent {\n  font-weight: 500;\n}\n.proceedButton :visited {\n  border: none !important;\n}\n:host /deep/ .queue-welcome-panel {\n  background-color: white;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/draft/dialogs/queue-welcome-container/queue-welcome.component.css
// module id = ./src/app/modules/draft/dialogs/queue-welcome-container/queue-welcome.component.css
// module chunks = main